import { render, staticRenderFns } from "./MubadalaDetail.vue?vue&type=template&id=56ea042a&scoped=true&"
import script from "./MubadalaDetail.vue?vue&type=script&lang=js&"
export * from "./MubadalaDetail.vue?vue&type=script&lang=js&"
import style0 from "./MubadalaDetail.vue?vue&type=style&index=0&id=56ea042a&scoped=true&lang=css&"
import style1 from "./MubadalaDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea042a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VDialog})
